module.exports = __webpack_public_path__ + "img/ziya.f9cc557b.png";